import React, { useEffect, useState } from 'react';
import defaultLogo from '../../../images/logo.png';
import './Spiner.css';  // Asegúrate de importar el archivo CSS donde definirás los estilos del spinner.
import baseURL from '../../url';
import { guardarSiteConfig, obtenerLogoGuardado } from '../../siteConfig';

export default function Spiner() {
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);

    useEffect(() => {
        const cargarLogo = async () => {
            try {
                const response = await fetch(`${baseURL}/configGet.php`);
                const data = await response.json();

                if (data.config) {
                    guardarSiteConfig(data.config);
                }

                if (data.config?.logo) {
                    setAppLogo(data.config.logo);
                }
            } catch (error) {
                console.error('Error al cargar el logo del spinner:', error);
            }
        };

        cargarLogo();
    }, []);

    return (
        <div className='spinnerContainer'>
            <div className='spinner'>
                <img src={appLogo} alt="Logo de la tienda" className='spinnerImage' />
                <p>Cargando...</p>
            </div>
        </div>
    );
}
